import React, { memo } from 'react';
import { SvgUniqueID } from '@financial/svg-manager';

const IconArrowRightBold = /*#__PURE__*/memo(_ref => {
  let {
    fill = '#000',
    width = '100%',
    height = '100%',
    viewBox = '0 0 6 10',
    id,
    style = {}
  } = _ref;
  return /*#__PURE__*/React.createElement(SvgUniqueID, {
    id: id
  }, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: viewBox,
    style: style
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    fillRule: "evenodd",
    stroke: fill,
    d: "M1 1l4 4-4 4"
  })));
});

export { IconArrowRightBold as default };
